import Grid from "@material-ui/core/Grid";
import React from "react";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {Link} from "react-router-dom";

export const ContentHeader: React.FC<{title: string, subtitle?: string, url?: string, id?: string}> = ({title, subtitle, url, id}) => {
    return (
        <StyledContentHeader id={id} item container direction={'column'} alignContent={"flex-start"}>
            <StyledContentHeaderChildren item>
                <Grid item>
                    <StyledContentHeaderP>{title}</StyledContentHeaderP>
                </Grid>

                {subtitle && url &&
                    <Grid item container direction={'column'} alignContent={"center"}>
                        <Link to={url}>
                            <StyledContentHeaderButton>{subtitle}</StyledContentHeaderButton>
                        </Link>
                    </Grid>
                }
            </StyledContentHeaderChildren>
        </StyledContentHeader>
    );
}

const StyledContentHeader = styled(Grid)`
  background: linear-gradient(180deg,
  rgba(0, 0, 0, 0) calc(50% - 1px),
  rgba(192, 192, 192, 1) calc(50%),
  rgba(0, 0, 0, 0) calc(50% + 1px));
  margin-top: 1rem;
`;

const StyledContentHeaderChildren = styled(Grid)`
  background-color: #FFF;
  padding: 0 20px 0 0;
`;

const StyledContentHeaderP = styled('p')`
  font-size: 1.5em;
  color: ${Colors.lightViolet};
  font-weight: 600;
`;

const StyledContentHeaderButton = styled('button')`
  margin-top: 5px;
  border: none;
  color: ${Colors.violet};
  font-weight: bold;
  cursor: pointer;
  background-color: transparent;
`;
